'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageWrapper(props) {
  var dataSeleniumTest = props.dataSeleniumTest,
      isOwnMessage = props.isOwnMessage,
      isAdmin = props.isAdmin,
      isLastInGroup = props.isLastInGroup,
      footer = props.footer,
      avatar = props.avatar,
      children = props.children;


  var contentClassName = (0, _classNames2.default)('chat-message m-top-1 chat-message-content', {
    'sender justify-end': isOwnMessage,
    'recipient justify-start': !isOwnMessage,
    'is-admin-screen': isAdmin
  });

  var avatarClassName = (0, _classNames2.default)('align-end', {
    'right-side-avatar': isOwnMessage,
    'widget-avatar-wrapper': !isAdmin
  });

  var footerClassName = (0, _classNames2.default)('align-end', {
    'p-left-7': !isOwnMessage,
    'p-right-6': isOwnMessage && isAdmin
  });

  var containerClassName = isLastInGroup ? 'm-bottom-2' : '';

  return _react2.default.createElement(
    'div',
    { className: containerClassName, 'data-selenium-test': dataSeleniumTest },
    _react2.default.createElement(
      'div',
      { className: contentClassName },
      _react2.default.createElement(
        'div',
        { className: avatarClassName },
        avatar
      ),
      children
    ),
    _react2.default.createElement(
      'div',
      { className: footerClassName },
      footer
    )
  );
}

MessageWrapper.propTypes = {
  avatar: _react.PropTypes.node,
  children: _react.PropTypes.node,
  dataSeleniumTest: _react.PropTypes.string.isRequired,
  footer: _react.PropTypes.node,
  isAdmin: _react.PropTypes.bool.isRequired,
  isLastInGroup: _react.PropTypes.bool.isRequired,
  isOwnMessage: _react.PropTypes.bool.isRequired
};

MessageWrapper.defaultProps = {
  dataSeleniumTest: '',
  isOwnMessage: false,
  isAdmin: false,
  isLastInGroup: false
};

exports.default = MessageWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/MessageWrapper.js
// module id = 156
// module chunks = 2 3